export default __webpack_public_path__ + "static/media/grid-alt.e01d0427.svg";